import './Header.css';
import headerBackground from '../../assets/header.png';

export default function Header(){
    return (
        <header className='header'>
            <img className='header__image' alt='header' src={headerBackground} />
        </header>
    );
}